export const nextUrl = (TT) => {
    switch (TT) {
        case 82:
            return "/TT82";
        case 28:
        case 29:
            return "/TT28";
        case 5:
        case 51:
        case 52:
            return "/audioTest";
        case 6:
        case 7:
        case 8:
        case 27:
            return "/typingTest";
        case 21:
            return "/TT21";
        case 24:
            return "/TT24";
        case 1:
        case 2:
        case 3:
        case 11:
        case 12:
        case 35:
            return "/simpleTest";
        case 70:
            return "/TT70";
        case 36:
            return "/TT36";
        case 32:
            return "/TT32";
        case 9:
            return "/survey";
        case 37:
            return "/TT37";
        default:
            break;
    }
};
